<template>
  <div>
    <div class="quick">
      <template v-for="(item,i) in menu">
        <a href="javascript:;" :key="i" @click="onClick(item)">
          <img :src="item.icon">
          <div>{{item.name}}</div>
        </a>
      </template>
    </div>
    <a
      class="ad"
      href="javascript:;"
      v-if="ad.open && ad.target!=='miniprogram'"
      @click="onClickAd"
    >
      <img :src="ad.image">
    </a>
  </div>
</template>
<script>
export default {
  computed: {
    menu() {
      return this.$service.other.setting.index_menu
    },
    ad() {
      return this.$service.other.setting.index_ad
    }
  },
  methods: {
    onClickAd() {
      this.onClick(this.ad)
    },
    onClick(item) {
      this.$service.other.goItem(item, this.$router)
    }
  }
}
</script>
<style scoped lang='scss'>
.ad {
  display: block;
  margin-top: 5px;
  img {
    width: 100%;
  }
}

.quick {
  display: flex;
  flex-wrap: wrap;
  background-color: $color-white;
  a {
    position: relative;
    width: 25%;
    padding: 10px 0;
    text-align: center;
    border-right: $style-border;
    border-bottom: $style-border;
    img {
      width: 27px;
      height: 27px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Quick.vue?ab624716